module.exports = __webpack_public_path__ + "static/media/lang-ptbr.27b1ebc0.svg";